import { render, staticRenderFns } from "./ResidentGroupEdit.vue?vue&type=template&id=6920964e&scoped=true&lang=pug"
import script from "./ResidentGroupEdit.vue?vue&type=script&lang=ts"
export * from "./ResidentGroupEdit.vue?vue&type=script&lang=ts"
import style0 from "./ResidentGroupEdit.vue?vue&type=style&index=0&id=6920964e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920964e",
  null
  
)

export default component.exports